import React, { useState } from "react";
import { Box, Typography, Button } from "@mui/material";
import { toast } from "react-toastify";
import DateRangePicker from "layouts/DateTimerange/dateTimeRange";

const InitializeJourney = ({
  thingId,
  onInitializeSuccess,
  onBack,
  selectedJourney,
}) => {

  // 👇 Today's Date
  const today = new Date();

  const yyyy = today.getFullYear();
  const mm = String(today.getMonth() + 1).padStart(2, "0");
  const dd = String(today.getDate()).padStart(2, "0");

  const todayDate = `${yyyy}-${mm}-${dd}`;

  // 👇 Default selected values
  const [dateRange, setDateRange] = useState({
    startTime: `${todayDate}T05:59`,
    endTime: `${todayDate}T17:59`,
  });

  // 👇 API format => YYYY/MM/DD HH:mm
  const formatDateTime = (dateTimeStr) => {
    if (!dateTimeStr) return "";

    const [date, time] = dateTimeStr.split("T");

    if (!date || !time) return "";

    const [year, month, day] = date.split("-");

    return `${year}/${month}/${day} ${time.substring(0, 5)}`;
  };

  // 👇 UI format => DD/MM/YYYY HH:mm
  const formatDisplayDateTime = (dateTimeStr) => {
    if (!dateTimeStr) return "";

    const [date, time] = dateTimeStr.split("T");

    if (!date || !time) return "";

    const [year, month, day] = date.split("-");

    return `${day}/${month}/${year} ${time.substring(0, 5)}`;
  };

  const handleInitialize = async () => {
    const { startTime, endTime } = dateRange;

    if (!startTime || !endTime) {
      toast.error("Please select both start and end times");
      return;
    }

    const payload = {
      thingId: thingId,
      journeyId: selectedJourney?.journeyId,
      interval: {
        timeZone: "Asia/Kolkata",
        startTime: formatDateTime(startTime),
        endTime: formatDateTime(endTime),
      },
    };

    try {
      const response = await fetch(
        "https://v3.dhundhoo.com/journey/initJourney",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-dhundhoo-session":
              window.localStorage.getItem("token") || "session",
          },
          body: JSON.stringify(payload),
        }
      );

      if (response.ok) {
        toast.success("Journey initialized successfully");
        onInitializeSuccess();
      } else {
        toast.error("Failed to initialize journey");
      }
    } catch (error) {
      console.error(error);
      toast.error("Error initializing journey");
    }
  };

  return (
    <Box
      sx={{
        p: 3,
        borderRadius: "8px",
        boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
        maxWidth: "450px",
        backgroundColor: "#fff",
      }}
    >
      <Typography variant="h6" align="center" mb={3}>
        {thingId}
      </Typography>

      {/* 👇 Custom Date Range Picker */}
      <Box mb={2}>
        <DateRangePicker
          startTime={dateRange.startTime}
          endTime={dateRange.endTime}
          onChange={(range) => setDateRange(range)}
        />
      </Box>

      {/* 👇 Preview */}
      {/* <Typography variant="body2" sx={{ mb: 1 }}>
        <strong>Start:</strong>{" "}
        {formatDisplayDateTime(dateRange.startTime)}
      </Typography>

      <Typography variant="body2" sx={{ mb: 2 }}>
        <strong>End:</strong>{" "}
        {formatDisplayDateTime(dateRange.endTime)}
      </Typography> */}

      <Box sx={{ display: "flex", gap: 2 }}>
        <Button
          variant="contained"
          color="info"
          onClick={handleInitialize}
        >
          Initialize Journey
        </Button>

        <Button
          variant="contained"
          color="inherit"
          onClick={onBack}
        >
          Back
        </Button>
      </Box>

      <Typography
        variant="caption"
        align="center"
        mt={2}
        display="block"
      >
        Initialize Journey by selecting date and time
      </Typography>
    </Box>
  );
};

export default InitializeJourney;